import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import { FormProps } from '../../utility/types';
import Spinner from '../../components/_common/Spinner';
import FormContainer from '../../components/FormContainer/FormContainer';
import CustomSelect from '../../components/_common/CustomSelect';
import { useForm } from '../../utility/useForm';
import { NoValidateForm } from '../../utility/validationRules';

import {
    Row,
    Space,
    Button,
    Modal,
    Col,
    List,
    Avatar,
} from "antd";
import React, { useEffect, useState } from "react";
import {
    getBranchOfficeVUser,
    getParsicUser,
    newBranchOfficeVUser,
} from "../../api/api";
import { EditFilled, DeleteFilled, UserOutlined,ExclamationCircleFilled } from "@ant-design/icons";



export const AssignUserDialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {
    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(NoValidateForm) as any
    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);
    const [users, setUsers] = useState([]);
    const [parsicUserList, setParsicUserList] = useState();
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);

    useEffect(() => {
        if (visible) {
            loadBranchOfficeVUsers();
        }
    }, [visible]);

    const loadBranchOfficeVUsers = () => {
        setIsLoading(true);

        getBranchOfficeVUser(payLoad.branchOfficeId)
            .then((result: any) => {
                setUsers(result.data.data)
                //setIsLoading(false);
                loadParsicUsers();
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    const loadParsicUsers = () => {

        getParsicUser()
            .then((result: any) => {
                setParsicUserList(result.data.data)
                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                setIsLoading(false);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }
    const onSubmitForm = (e: any) => {
        e.preventDefault();

        setIsSubmiting(true)
        var model = {
            "mode": payLoad.mode,
            "branchOfficeId": payLoad.branchOfficeId,
            "branchOfficeVUserId": 0,
            "branchOfficeVStateId": 0,
            "stateId": 0,
            "userId": values.parsicUser,
            "branchName": "",
            "branchDesc": ""
        }
        newBranchOfficeVUser(model).then((result: any) => {
            sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
            onCancel();
            setIsSubmiting(false)
        })
            .catch((error) => {
                console.log(error);
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }


const deleteOfficeVUserOnClick = (id: number) => {
  Modal.confirm({
    title: "حذف کاربر",
    icon: <ExclamationCircleFilled style={{ color: "#faad14" }} />,

    content: "آیا از حذف این کاربر مطمئن هستید؟",

    cancelText: "انصراف",
    okText: "بله، حذف شود",
    okType: "danger",

    direction: "rtl",

    okButtonProps: {
      style: { marginLeft: 0 },
    },
  
    cancelButtonProps: {
      style: { marginLeft: 0 },
    },

    onOk: () => {
      const model = {
        mode: 2,
        branchOfficeId: 0,
        branchOfficeVUserId: payLoad.branchOfficeId,
        branchOfficeVStateId: 0,
        stateId: 0,
        userId: id,
        branchName: "",
        branchDesc: "",
      };

      return newBranchOfficeVUser(model)
        .then(() => {
          sucessNotify("کاربر با موفقیت حذف شد", undefined, 5000);
          loadBranchOfficeVUsers();
        })
        .catch((error) => {
          errorNotify(error.response.data.errorMessage, undefined, 5000);
        });
    },
  });
};





    const editOfficeVUserOnClick = (id: number) => {
        setSelectedUserId(id);
        setEditModalVisible(true);
    };
    const submitEdit = () => {
        const model = {
            mode: 1,
            branchOfficeId: payLoad.branchOfficeId,
            branchOfficeVUserId: selectedUserId,
            stateId: 0,
            userId: values.editUser,
        };

        newBranchOfficeVUser(model)
            .then(() => {
                sucessNotify("ویرایش با موفقیت انجام شد", undefined, 5000);
                setEditModalVisible(false);
                loadBranchOfficeVUsers();
            })
            .catch((error) => {
                errorNotify(error.response.data.errorMessage, undefined, 5000);
            });
    };


    return (
        <>
            <Modal
                visible={visible}
                onCancel={onCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
                
            >
                <>
                    {isLoading === true && (
                        <Spinner />
                    )}
                    {isLoading === false && (

                        <FormContainer title="انتصاب کاربر" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                     {users.length>0 && <Row>
                                <Col span={24}>
                                    <List
                                        dataSource={users}
                                        bordered
                                        renderItem={(item: any) => (
                                            <List.Item>
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        direction: "ltr",
                                                    }}
                                                >
                                                    <Space size="small">
                                                        <Button
                                                            onClick={() => editOfficeVUserOnClick(item.prk_BranchOfficeVUserAutoID)}
                                                            type="text"
                                                            icon={<EditFilled style={{ color: "#1677ff", fontSize: 16 }} />}
                                                            style={{ borderRadius: 6 }}
                                                        />

                                                        <Button
                                                            onClick={() => deleteOfficeVUserOnClick(item.prk_BranchOfficeVUserAutoID)}
                                                            type="text"
                                                            icon={<DeleteFilled style={{ color: "#ff4d4f", fontSize: 16 }} />}
                                                            style={{ borderRadius: 6 }}
                                                        />
                                                    </Space>

                                                    <Space style={{ direction: "rtl" }}>
                                                        <Avatar icon={<UserOutlined />} />
                                                        {item.str_FullName}
                                                    </Space>
                                                </div>
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
}
                            <Row>
                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <CustomSelect
                                        name="parsicUser"
                                        placeholder="کاربر"
                                        itemList={parsicUserList}
                                        value={values.parsicUser || ""}
                                        onChange={handleChange}
                                        valueObjectField={"prk_ParsicUser_AutoID"}
                                        displayObjectField={"str_FullName"}
                                    />
                                </Col>
                            </Row>

                        </FormContainer>

                    )}
                </>

            </Modal>

            <Modal
                open={editModalVisible}
                onCancel={() => setEditModalVisible(false)}
                onOk={() => submitEdit()}
                okText="ویرایش"
                cancelText="انصراف"
            >
                <CustomSelect
                    name="editUser"
                    placeholder="انتخاب کاربر جدید"
                    itemList={parsicUserList}
                    value={values.editUser || ""}
                    onChange={handleChange}
                    valueObjectField="prk_ParsicUser_AutoID"
                    displayObjectField="str_FullName"
                />
            </Modal>
        </>
    )
};

